var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.canvasStyle)},[_c('b-skeleton',{attrs:{"width":`${_vm.scaledViewport.width}px`,"height":`${_vm.scaledViewport.height}px`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }